"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getButtonHtml = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("../../components/Button/Button"));
var _conditionalAttributes = require("../conditionalAttributes/conditionalAttributes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Function for button action style
 * @function getButtonHtml
 * @param { object }  - returns an object with the appropriate HTML markup for link
 */
const getButtonHtml = data => {
  const {
    /* ActionGroup props */
    action,
    fullyClickableParent,
    isKnockoutLink,
    textForScreenReaders,
    // used when a component is fully clickable. If false will add a tab-index = -1 to avoid duplicate links for ADA
    /* ActionGroupDefault props */
    actionStyle,
    actionSize,
    derivedAriaLabel
  } = data;
  const hasNegIndex = !textForScreenReaders && fullyClickableParent;
  const updateTabIndex = hasNegIndex ? -1 : undefined;
  const updateAriaHidden = hasNegIndex ? 'true' : undefined;
  const needAriaLabel = !hasNegIndex && !textForScreenReaders;
  const updateAriaLabel = needAriaLabel ? derivedAriaLabel : undefined;
  const conditionalProps = (0, _conditionalAttributes.conditionalAttributes)({
    'aria-hidden': updateAriaHidden,
    ariaLabel: updateAriaLabel,
    tabIndex: updateTabIndex
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, _extends({}, action, conditionalProps, {
    fullyClickableParent: fullyClickableParent,
    isKnockoutLink: isKnockoutLink,
    screenReaderText: derivedAriaLabel,
    size: actionSize,
    variant: actionStyle
  })));
};
exports.getButtonHtml = getButtonHtml;